module.exports = __webpack_public_path__ + "img/money-in-select.svg";